import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { AiOutlineClose } from "react-icons/ai";
function MeetingsFileModal({ close, files, setFiles, setSelectedSession }) {
    const closeModal = (e) => {
        e.stopPropagation();
        setFiles("");
        setSelectedSession();
        close();
    };
    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={closeModal}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <div className=" w-full max-w-[60.6rem] min-w-[40rem]">
                <h5 className=" mb-20 font-bold text-[2rem] text-purple-dark text-center">
                    فایل‌های آپلود شده
                </h5>
                <ul className="w-full">
                    {files?.map((file) => (
                        <li className="flex justify-center border-b border-[#9C5FA4] w-full py-4 text-[1.8rem] leading-[3.2rem] text-[#21212199] ">
                            <span
                                onClick={() => {
                                    window.open(file?.file);
                                }}
                                className="cursor-pointer"
                            >
                                {file?.file}
                            </span>

                            <AiOutlineClose className=" text-[#9C5FA4] text-[1.4rem]" />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default MeetingsFileModal;
const files = [{ name: "تیزر.mp4" }, { name: "پاورپوینت ارائه.pdf" }];
